import React, { useState, useEffect } from "react";
import { Field } from "formik";

import FileUploader from "react-firebase-file-uploader";
import { storage } from "../../util/firebase";
import useImage from "../../util/useImage";
import loading from "../../assets/loading.svg";
import { motion, AnimatePresence } from "framer-motion";
import Upload from "../../assets/logo.svg";
import { useData } from "../../util/dataProvider";
import Resizer from "react-image-file-resizer";

export default function Page1({
    setPage,
    page,
    values,
    setFieldValue,
    validateForm,
    errors,
    touched,
}) {
    const url = useImage(values.image);
    const { assetUrl, setSubmitError } = useData();
    const [logoUrl, setLogoUrl] = useState();
    const [headerUrl, setHeaderUrl] = useState(null);
    const url2 = useImage(values.header);

    function handleUpload(filename) {
        setFieldValue("image", "images/" + filename);
        storage
            .ref("images")
            .child(filename)
            .getDownloadURL()
            .then((url) => setLogoUrl(url));
    }

    useEffect(() => {
        setLogoUrl(url);
    }, [url]);

    useEffect(() => {
        setSubmitError(null);
    }, []);

    function validatePLZ(value) {
        let error;
        if (!value) {
            error = "*Required";
        } else if (!/^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/.test(value)) {
            error = "PLZ ist nicht richtig";
        } else {
            error = null;
        }
        return error;
    }

    function validate(value) {
        let error;
        if (!value) {
            error = "*Pflichtfeld";
        } else {
            error = null;
        }
        return error;
    }

    function isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    useEffect(() => {
        setHeaderUrl(url2);
    }, [url2]);

    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                300,
                300,
                "JPEG",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64"
            );
        });

    function handleHeaderUpload(filename) {
        setFieldValue("header", "images/" + filename);
        storage
            .ref("images")
            .child(filename)
            .getDownloadURL()
            .then((url) => setHeaderUrl(url));
    }

    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className='page1-form'>
                <div className='left-part'>
                    <label htmlFor='experte-firstname' className='label'>
                        Vorname
                    </label>
                    <Field
                        id='experte-firstname'
                        name='firstname'
                        type='text'
                        validate={validate}
                    />
                    {errors.firstname && touched.firstname && (
                        <div className='errors'>{errors.firstname}</div>
                    )}

                    <label htmlFor='experte-lastname' className='label'>
                        Nachname
                    </label>
                    <Field
                        id='experte-lastname'
                        name='lastname'
                        type='text'
                        validate={validate}
                    />
                    {errors.lastname && touched.lastname && (
                        <div className='errors'>{errors.lastname}</div>
                    )}

                    <label htmlFor='experte-gender' className='label'>
                        Geschlecht
                    </label>

                    <Field
                        as='select'
                        id='experte-gender'
                        name='gender'
                        type='text'
                        validate={validate}>
                        <option value=''>Bitte wählen</option>

                        <option value='Männlich'>Männlich</option>
                        <option value='Weiblich'>Weiblich</option>
                        <option value='Divers'>Divers</option>
                    </Field>

                    {errors.gender && touched.gender && (
                        <div className='errors'>{errors.gender}</div>
                    )}

                    <label htmlFor='experte-street_number' className='label'>
                        Straße und Nr
                    </label>
                    <Field
                        id='experte-street_number'
                        name='street_number'
                        type='text'
                        validate={validate}
                    />

                    {errors.street_number && touched.street_number && (
                        <div className='errors'>{errors.street_number}</div>
                    )}

                    <div className='form-3-7'>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                            }}>
                            <label htmlFor='experte-zip' className='label'>
                                Postleitzahl
                            </label>
                            <Field
                                id='experte-zip'
                                name='zip'
                                type='number'
                                validate={validatePLZ}
                            />

                            {errors.zip && touched.zip && (
                                <div className='errors'>{errors.zip}</div>
                            )}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                            }}>
                            <label htmlFor='experte-city' className='label'>
                                Ort
                            </label>
                            <Field
                                id='experte-city'
                                name='city'
                                type='text'
                                validate={validate}
                            />
                            {errors.city && touched.city && (
                                <div className='errors'>{errors.city}</div>
                            )}
                        </div>
                    </div>
                    <label htmlFor='experte-phone' className='label'>
                        Telefon
                    </label>
                    <Field
                        id='experte-phone'
                        name='phone'
                        type='text'
                        validate={validate}
                    />
                    {errors.phone && touched.phone && (
                        <div className='errors'>{errors.phone}</div>
                    )}
                    <label htmlFor='experte-fach' className='label'>
                        Fachgebiet
                    </label>
                    <Field
                        id='experte-fach'
                        name='field'
                        type='text'
                        validate={validate}
                    />
                    {errors.field && touched.field && (
                        <div className='errors'>{errors.field}</div>
                    )}
                    <label htmlFor='experte-Unternehmen' className='label'>
                        Unternehmen
                    </label>
                    <Field
                        id='experte-Unternehmen'
                        name='employees'
                        type='text'
                    />
                    <label htmlFor='experte-website' className='label'>
                        Webseite
                    </label>
                    <Field id='experte-website' name='website' type='text' />
                </div>
                <div className='left-part'>
                    <label htmlFor='header-bild' className='label'>
                        Titelbild
                    </label>
                    <div
                        className='photoupload'
                        style={{
                            backgroundImage: `url(${assetUrl + Upload})`,
                        }}>
                        <FileUploader
                            accept='image/*'
                            name='avatar'
                            randomizeFilename
                            beforeUploadStart={(file) => {
                                if (file.size > 2 * 1024 * 1024) {
                                    alert("Bitte Bild unter 2MB hochladen!");
                                    throw Error("File Size error");
                                }else if(file.type !== "image/jpeg" && file.type !== "image/png" && file.type!='image/svg'){
                                        alert("Bitte verwenden Sie eines der folgenden Dateiformate: .jpg, .png, .svg");
                                        throw Error("File type error");
                                    }
                            }}
                            storageRef={storage.ref("images")}
                            maxHeight={800}
                            maxWidth={800}
                            onUploadStart={(file) => {
                                resizeFile(file).then((res) => {
                                    setHeaderUrl(assetUrl + loading);
                                    return res;
                                });
                            }}
                            onUploadSuccess={handleHeaderUpload}
                        />
                        {headerUrl && (
                            <img
                                src={headerUrl}
                                alt='Logo'
                                style={{ maxHeight: "90%" }}
                            />
                        )}
                    </div>
                    <label htmlFor='logo' className='label'>
                        Profilbild
                    </label>
                    <div
                        className='photoupload'
                        style={{
                            backgroundImage: `url(${assetUrl + Upload})`,
                        }}>
                        <FileUploader
                            accept='image/*'
                            name='avatar'
                            beforeUploadStart={(file) => {
                                if (file.size > 2 * 1024 * 1024) {
                                    alert("Bitte Bild unter 2MB hochladen!");
                                    throw Error("File Size error");
                                }else if(file.type !== "image/jpeg" && file.type !== "image/png" && file.type!='image/svg'){
                                        alert("Bitte verwenden Sie eines der folgenden Dateiformate: .jpg, .png, .svg");
                                        throw Error("File type error");
                                    }
                            }}
                            randomizeFilename
                            storageRef={storage.ref("images")}
                            onUploadStart={() => setLogoUrl(assetUrl + loading)}
                            onUploadSuccess={handleUpload}
                        />
                        {logoUrl && (
                            <img
                                src={logoUrl}
                                alt='Logo'
                                style={{ maxHeight: "90%" }}
                            />
                        )}
                        {logoUrl && <div></div>}
                    </div>
                    <label htmlFor='experte-description' className='label'>
                        Kurze Beschreibung Ihrer Expertise
                    </label>
                    <Field
                        id='companmy-description'
                        name='description'
                        as='textarea'
                        maxlength='500'
                        style={{ height: "300px" }}
                    />
                     <div style={{textAlign:'end',marginTop:'4px',color:'#999',fontSize:'16px'}}>
                            {values.description? values.description.length :0 }/500
                    </div>
                    <button
                        className='button-red'
                        onClick={() =>
                            validateForm().then((errors) => {
                                if (isEmpty(errors)) {
                                    setPage(page + 1);
                                } else {
                                    console.log("errors: ", errors);
                                }
                            })
                        }>
                        Weiter
                    </button>
                </div>
            </motion.div>
        </AnimatePresence>
    );
}
